module.exports = __webpack_public_path__ + "static/aws-certified-cloud-practitioner-b6845af02b63b9dd2f1b333b4590f4e2.png";